import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Quote, CheckCircle2, Star } from 'lucide-react';

export const Testimonials = () => {
  const { t } = useTranslation();
  const testimonials = t('testimonials.items', { returnObjects: true }) as any[];

  const getInitials = (name: string) => {
    if (!name) return '??';
    const words = name.split(' ');
    if (words.length > 1 && words[0] && words[1]) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  return (
    <section className="py-32 bg-slate-950 relative overflow-hidden">
       {/* Background Effects */}
       <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(6,182,212,0.05),transparent_70%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-24">
           
          <h2 className="text-4xl md:text-6xl font-black text-white tracking-tight leading-none mb-6">
            La Verità <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600">Decriptata</span>
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-400 leading-relaxed">
            Non fidarti del marketing. Fidati dei log di sistema. Ecco cosa succede quando le aziende emiliane installano il nostro kernel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-500" />
              
              <div className="relative h-full bg-slate-900/80 backdrop-blur-sm border border-slate-800 p-8 rounded-2xl transition-all duration-300 hover:border-cyan-500/30 hover:-translate-y-1">
                
                {/* "Verified" Badge */}
                <div className="absolute top-0 right-0 p-6">
                   <div className="flex items-center gap-1 text-[10px] font-mono text-green-500 bg-green-500/10 px-2 py-1 rounded border border-green-500/20">
                      <CheckCircle2 size={10} /> VERIFIED_ROI
                   </div>
                </div>

                <div className="mb-6 text-cyan-500/20">
                   <Quote size={40} />
                </div>

                <blockquote className="text-slate-300 text-lg leading-relaxed mb-8 font-medium">
                  "{testimonial.quote}"
                </blockquote>

                <div className="flex items-center gap-4 border-t border-slate-800 pt-6">
                  <div className="flex-shrink-0">
                    {testimonial.image ? (
                      <img className="h-12 w-12 rounded-full object-cover border-2 border-slate-700" src={testimonial.image} alt={testimonial.name} />
                    ) : (
                      <div className="h-12 w-12 rounded-full bg-gradient-to-br from-slate-800 to-slate-700 border border-slate-600 flex items-center justify-center shadow-inner">
                        <span className="text-sm font-bold text-cyan-400 font-mono">{getInitials(testimonial.name)}</span>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="font-bold text-white text-base">{testimonial.name}</div>
                    <div className="text-sm text-slate-500 font-mono">{testimonial.role}</div>
                  </div>
                </div>

                {/* Fake "Metrics" for added tech vibe */}
                {index === 0 && (
                   <div className="absolute bottom-4 right-4 hidden sm:flex gap-1">
                      <Star size={12} className="text-yellow-500 fill-yellow-500" />
                      <Star size={12} className="text-yellow-500 fill-yellow-500" />
                      <Star size={12} className="text-yellow-500 fill-yellow-500" />
                      <Star size={12} className="text-yellow-500 fill-yellow-500" />
                      <Star size={12} className="text-yellow-500 fill-yellow-500" />
                   </div>
                )}

              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
